<dx-date-box
    #datebox
    [ngClass]="{'date-picker' : type === 'date', 'date-picker-list' : type === 'time'}"
    [acceptCustomValue]="acceptCustomValue"
    [calendarOptions]="calendarOptions"
    [id]="id"
    [dateSerializationFormat]="dateSerializationFormat"
    [disabled]="disabled"
    [displayFormat]="displayFormat"
    [interval]="interval"
    [invalidDateMessage]="invalidDateMessage"
    [max]="max"
    [min]="min"
    [pickerType]="pickerType"
    [placeholder]="placeholder"
    [readOnly]="readOnly"
    [showClearButton]="showClearButton"
    [type]="type"
    [width]="width"
    [value]="value"
    (onFocusOut)="onDatePickerFocusOutEvent($event)"
    (onKeyDown)="onDatePickerKeyDownEvent($event)"
    (onValueChanged)="onDatedPickerValueChangedEvent($event)">
    <dxo-drop-down-options *ngIf="type=='date'" [toolbarItems]="dateBoxToolbarItems"></dxo-drop-down-options>
    <dxi-button name="dropDown"></dxi-button>
    <dx-validator *ngIf="isRequiredValidator">
        <dxi-validation-rule
          type="required"
          [message]="requiredValidationMessage"
        ></dxi-validation-rule>
    </dx-validator>
</dx-date-box>